<!--
This file is part of the project: "Digiziege"
An app for animal-welfare-oriented goat husbandry and contactless weight estimation.
GitLab: https://gitlab.rlp.net/proj-wise2526-digiziege/digiziege

Copyright (c) 2026 Digiziege Team TH-Bingen

Description:
Companion app for welfare-oriented goat husbandry featuring contactless weight estimation via camera,
master data management and health tracking.
Built as a PWA with a local-first approach to ensure data privacy.

LICENSE INFORMATION:
This program is free software: you can redistribute it and/or modify it under the terms of the
GNU Affero General Public License as published by the Free Software Foundation,
either version 3 of the License, or (at your option) any later version.

This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
See the GNU Affero General Public License for more details.

You should have received a copy of the GNU Affero General Public License along with this program.
If not, see <https://www.gnu.org/licenses/>.
-->

<template>
  <InputPopupModule
    v-model:show="isOpen"
    :title="title"
    :subtitle="subtitle"
    :hide-actions="true"
    @cancel="handleCancel">
    <template #content>
      <div class="flex gap-4">
        <button
          @click="selectDirection('left')"
          class="flex-1 py-3 px-4 rounded-lg font-medium text-base transition flex items-center justify-center gap-2 bg-[var(--color-primary-100)] text-[var(--color-text)] border border-[var(--color-primary-400)] active:bg-[var(--color-highlight)] active:text-white">
          <ArrowLeft class="w-5 h-5" />
          <span>{{ $t('views.segmentation.left') }}</span>
        </button>
        <button
          @click="selectDirection('right')"
          class="flex-1 py-3 px-4 rounded-lg font-medium text-base transition flex items-center justify-center gap-2 bg-[var(--color-primary-100)] text-[var(--color-text)] border border-[var(--color-primary-400)] active:bg-[var(--color-highlight)] active:text-white">
          <ArrowRight class="w-5 h-5" />
          <span>{{ $t('views.segmentation.right') }}</span>
        </button>
      </div>
    </template>
  </InputPopupModule>
</template>

<script setup>
  import { computed } from 'vue'
  import { ArrowLeft, ArrowRight } from 'lucide-vue-next'
  import InputPopupModule from '@/components/ui/inputs/InputPopupModule.vue'

  const props = defineProps({
    show: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    subtitle: {
      type: String,
      default: '',
    },
  })

  const emit = defineEmits(['select', 'cancel', 'update:show'])

  const isOpen = computed({
    get: () => props.show,
    set: (value) => emit('update:show', value),
  })

  function selectDirection(direction) {
    emit('select', direction)
    isOpen.value = false
  }

  function handleCancel() {
    emit('cancel')
  }
</script>

<style scoped>
  /* Component-specific styles only */
</style>
